import {FC} from 'react'
import { useIntl } from 'react-intl';
import classNames from 'classnames'

interface Props {
  message?: string
  showMessage?: boolean
  withClass?: string
  heightClass?: string
}

const Spinner: FC<Props> = ({
  message,
  showMessage = false,
  withClass = 'w-100px',
  heightClass = 'h-100px',
}) => {
  const intl = useIntl()

  return (
    <div className='row'>
      <div className={`d-flex flex-row-fluid flex-center ${withClass} ${heightClass}`}>
        <div className='spinner-border text-primary'>
          <span
            className={classNames({
              'visually-hidden': !showMessage,
              '': showMessage,
            })}
          >
            {message || intl.formatMessage({id: 'LOADING'})}
          </span>
        </div>
      </div>
    </div>
  )
}

export {Spinner}
